import React from 'react';
import { ShoppingCart, Heart } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ product }) => {
    const { addToCart } = useCart();
    const navigate = useNavigate();

    const handleAddToCart = (e) => {
        e.stopPropagation();
        addToCart(product);
    };

    const handleCardClick = () => {
        navigate(`/product/${product.slug}`);
    };

    const getStockStatus = () => {
        if (product.stockQuantity === 0) return { text: 'Out of Stock', color: 'text-red-600 bg-red-50' };
        if (product.stockQuantity < 10) return { text: 'Low Stock', color: 'text-orange-600 bg-orange-50' };
        return { text: 'In Stock', color: 'text-green-600 bg-green-50' };
    };

    const stockStatus = getStockStatus();

    return (
        <div
            onClick={handleCardClick}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group"
        >
            {/* Image */}
            <div className="relative overflow-hidden aspect-[4/3]">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                {/* Stock Badge */}
                <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${stockStatus.color}`}>
                    {stockStatus.text}
                </div>
                {/* Wishlist Button - Future Feature */}
                <button className="absolute top-3 left-3 p-2 bg-white rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
                    <Heart className="w-4 h-4 text-gray-600" />
                </button>
            </div>

            {/* Content */}
            <div className="p-4">
                {/* Category */}
                <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">{product.category}</p>

                {/* Name */}
                <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2 min-h-[3rem]">{product.name}</h3>

                {/* Price */}
                <div className="flex items-center justify-between mb-3">
                    <span className="text-2xl font-bold text-primary">₹{product.price.toLocaleString('en-IN')}</span>
                </div>

                {/* Features Preview */}
                {product.features && product.features.length > 0 && (
                    <div className="mb-3">
                        <ul className="text-xs text-gray-600 space-y-1">
                            {product.features.slice(0, 2).map((feature, index) => (
                                <li key={index} className="flex items-start">
                                    <span className="text-primary mr-1">✓</span>
                                    <span className="line-clamp-1">{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Add to Cart Button */}
                <button
                    onClick={handleAddToCart}
                    disabled={product.stockQuantity === 0}
                    className={`w-full py-2.5 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 ${product.stockQuantity === 0
                            ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                            : 'bg-primary hover:bg-primary-strong text-white hover:shadow-lg'
                        }`}
                >
                    <ShoppingCart className="w-4 h-4" />
                    {product.stockQuantity === 0 ? 'Out of Stock' : 'Add to Cart'}
                </button>
            </div>
        </div>
    );
};

export default ProductCard;
